import React, { Component } from 'react';
import { Header, Checkbox, Button, Modal, Input, Form, Message, List } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { profileSelector } from '../../selectors';
import * as profileActions from '../../actions/profileActions';
import styles from './ElectronicDelivery.module.scss';

class ElectronicDelivery extends Component {
	constructor(props) {
		super(props);
		const { profile } = props;
		this.state = {
			showConfirmation: false,
			showSuccess: false,
			editMobileNumber: false,
			phoneNumber: profile ? profile.phoneNumber : null,
			error: null,
			formDirty: false,
			errorHeader: null,
			additionalPhoneNumber: '',
			additionalPhoneNumberError: false,
			additionalEmailAddress: '',
			additionalEmailAddressError: false,
		};
		this.onToggleDelivery = this.onToggleDelivery.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onRealSave = this.onRealSave.bind(this);
		this.onCloseSuccess = this.onCloseSuccess.bind(this);
		this.onEditMobile = this.onEditMobile.bind(this);
		this.onSaveMobile = this.onSaveMobile.bind(this);
		this.onPhoneNumberChange = this.onPhoneNumberChange.bind(this);
		this.onCancelMobileEdit = this.onCancelMobileEdit.bind(this);
		this.onAdditionalPhoneNumberChange = this.onAdditionalPhoneNumberChange.bind(this);
		this.onAdditionalEmailAddressChange = this.onAdditionalEmailAddressChange.bind(this);
		this.onAddAdditionalPhoneNumber = this.onAddAdditionalPhoneNumber.bind(this);
		this.onAddAdditionalEmailAddress = this.onAddAdditionalEmailAddress.bind(this);
		this.onRemoveAdditionalEmailAddress = this.onRemoveAdditionalEmailAddress.bind(this);
		this.onRemoveAdditionalPhoneNumber = this.onRemoveAdditionalPhoneNumber.bind(this);

		this.temporaryMobile = '';
	}

	onToggleDelivery(e, { name, checked }) {
		const { actions } = this.props;
		const options = { [name]: checked };
		if (name === 'isDelivery' && checked) {
			options.isDeliveryViaEmail = true;
			options.isClaimDeliveryViaEmail = true;
			options.isDeliveryViaText = false;
			options.isClaimDeliveryViaText = false;
			options.OptIn = true;
            options.HasConsent = true;
		} else if (name === 'isDelivery' && !checked) {
			options.isDeliveryViaEmail = false;
			options.isDeliveryViaText = false;
			options.isClaimDeliveryViaEmail = false;
			options.isClaimDeliveryViaText = false;
			options.OptIn = false;
			options.HasConsent = false;
		}
		if (name === 'isDeliveryViaEmail' && checked) {
			options.isDeliveryViaEmail = true;
			options.isClaimDeliveryViaEmail = true;
		} else if (name === 'isDeliveryViaEmail' && !checked) {
			options.isDeliveryViaEmail = false;
			options.isClaimDeliveryViaEmail = false;
		}

		if (name === 'isDeliveryViaText' && checked) {
			options.isDeliveryViaText = true;
			options.isClaimDeliveryViaText = true;
		} else if (name === 'isDeliveryViaText' && !checked) {
			options.isDeliveryViaText = false;
			options.isClaimDeliveryViaText = false;
		}

		actions.configureDelivery(options);
		this.setState({ formDirty: true });
	}

	onSave(e) {
		const { profile } = this.props;
		if (profile.isDelivery) {
			if (!profile.isDeliveryViaEmail && !profile.isDeliveryViaText && !profile.isClaimDeliveryViaEmail && !profile.isClaimDeliveryViaText) {
				return this.setState({ showError: true, error: 'To receive your documents and notifications electronically, either Email or Text must be selected.', errorHeader: 'Changes could not be saved.' });
			}
			this.setState({ showConfirmation: true });
		} else {
			this.onRealSave(e);
		}
		this.setState({ formDirty: false });
	}

	onCloseSuccess(e) {
		this.setState({ showConfirmation: false, showSuccess: false, showError: false });
	}

	onEditMobile(e) {
		e.preventDefault();

		// check if the form is dirty.  If so, prompt user to save changes before continuing
		const { formDirty } = this.state;
		if (formDirty) {
			return this.setState({ showError: true, error: 'Please save your current changes before updating the phone number.', errorHeader: 'Warning' });
		}
		// stash the current value
		const { phoneNumber } = this.state;
		this.temporaryMobile = phoneNumber;

		this.setState({ editMobileNumber: true });
	}

	onCancelMobileEdit(e) {
		e.preventDefault();
		const { profile } = this.props;
		if (!this.temporaryMobile || this.temporaryMobile.trim() === '') {
			profile.isClaimDeliveryViaText = false;
			profile.isDeliveryViaText = false;
		}
		this.setState({ editMobileNumber: false, phoneNumber: this.temporaryMobile });
	}

	async onSaveMobile(e) {
		e.preventDefault();
		const { actions, profile } = this.props;
		const { phoneNumber } = this.state;

		if (phoneNumber !== profile.phoneNumber) {
			if (phoneNumber && phoneNumber.trim() !== '') {
				const stripped = phoneNumber.replace(/\D/g, '');
				await actions.updateMobilePhone({ ...profile, phoneNumber: stripped });
			} else {
				const newNumber = phoneNumber ? phoneNumber.trim() : phoneNumber;
				await actions.updateMobilePhone({ ...profile, phoneNumber: newNumber, isDeliveryViaText: false, isClaimDeliveryViaText: false, isDelivery: profile.isDeliveryViaEmail || profile.isClaimDeliveryViaEmail, additionalEDeliverySMSRecipients: [] });
			}
		}

		this.setState({ editMobileNumber: false });
	}

	onPhoneNumberChange(e, { value }) {
		this.setState({ phoneNumber: value });
	}

	onAdditionalPhoneNumberChange(_, { value }) {
		this.setState({ additionalPhoneNumber: value, additionalPhoneNumberError: false });
	}

	onAddAdditionalPhoneNumber() {
		const { actions, profile } = this.props;
		const { additionalPhoneNumber } = this.state;

		const stripped = additionalPhoneNumber.replace(/\D/g, '').toLowerCase().trim();

		if (profile.additionalEDeliverySMSRecipients.find((er) => er.toLowerCase() === stripped) || stripped === profile.phoneNumber.toLowerCase()) {
			this.setState({ additionalPhoneNumberError: true });
			return;
		}

		actions.configureDelivery({ additionalEDeliverySMSRecipients: [...profile.additionalEDeliverySMSRecipients, stripped] });
		this.setState({ additionalPhoneNumber: '' });
	}

	onRemoveAdditionalPhoneNumber(phoneNumber) {
		const { actions, profile } = this.props;
		actions.configureDelivery({ additionalEDeliverySMSRecipients: profile.additionalEDeliverySMSRecipients.filter((pn) => pn !== phoneNumber) });
	}

	onAdditionalEmailAddressChange(_, { value }) {
		this.setState({ additionalEmailAddress: value, additionalEmailAddressError: false });
	}

	onAddAdditionalEmailAddress() {
		const { actions, profile } = this.props;
		const { additionalEmailAddress } = this.state;

		var trimmedAdditionalEmailAddress = additionalEmailAddress.toLowerCase().trim();

		if (profile.additionalEDeliveryEmailRecipients.find((er) => er.toLowerCase() === trimmedAdditionalEmailAddress) || trimmedAdditionalEmailAddress === profile.email.toLowerCase()) {
			this.setState({ additionalEmailAddressError: true });
			return;
		}

		actions.configureDelivery({ additionalEDeliveryEmailRecipients: [...profile.additionalEDeliveryEmailRecipients, trimmedAdditionalEmailAddress] });
		this.setState({ additionalEmailAddress: '' });
	}

	onRemoveAdditionalEmailAddress(emailAddress) {
		const { actions, profile } = this.props;
		actions.configureDelivery({ additionalEDeliveryEmailRecipients: profile.additionalEDeliveryEmailRecipients.filter((ea) => ea !== emailAddress) });
	}

	async onRealSave(e) {
		const { actions, profile } = this.props;
		try {
			await actions.saveDeliveryOptions(profile);
			this.setState({ showConfirmation: false, showSuccess: true });
		} catch (error) {
			this.setState({ error: error.message, showConfirmation: false, showError: true, errorHeader: 'Changes could not be saved.' });
			console.log(error);
			throw error;
		}
	}

	render() {
		const { profile } = this.props;
		const { showConfirmation, showSuccess, editMobileNumber, phoneNumber, showError, error, errorHeader, additionalPhoneNumber, additionalPhoneNumberError, additionalEmailAddress, additionalEmailAddressError } = this.state;

		return (
			<div>
				<Modal size='tiny' open={showConfirmation && profile.isDelivery}>
					<Modal.Header>e-Delivery Consent</Modal.Header>
					<Modal.Content>
						<div style={{ height: '400px', width: 'auto', overflowX: 'hidden', overflowY: 'scroll' }}>
							<p>As a condition of my agreement to conduct business with Indiana Farmers Mutual Insurance Group and its affiliated insurance companies ("Company") electronically, I agree to receive information &amp; notifications from the Company, via text messages and/or email. I understand this program is completely voluntary and that text messaging rates &amp; fees may apply as determined by my cellular provider. I agree not to hold the Company liable for any electronic messaging charges or fees generated by this service.&nbsp; I further agree that in the event my contact/cell phone number changes that I will inform the Company or be liable for any fees or charges incurred.&nbsp; If at any time I wish to discontinue receiving text messages from the Company, I can opt-out of text message notification via a reply text message. This, as well as opting out of email notifications, may also be accomplished by changing my preferences via my Member Portal account.&nbsp; I will receive a text message confirmation and/or an email notification that I have been signed up for this program.&nbsp; By clicking the &ldquo;Accept&rdquo; button, I am providing consent to the terms and conditions of this Agreement.</p>
							<p>CONSENT AND NOTICE REGARDING TEXT MESSAGE AUTHORIZATION</p>
							<p>&nbsp;</p>
							<ol>
								<li>
									<u>Consent to Automatic Text Message and/or Email Notifications</u>. You specifically agree to receive and/or obtain text messages from the Company via an automatic text messaging system and/or email.
								</li>
							</ol>
							<p style={{ marginLeft: '.5in' }}>&nbsp;</p>
							<ol start='2'>
								<li>
									<u>Paper version of the Agreement</u>. You acknowledge that, for your records, you are able to retain a copy of this Agreement by printing and/or downloading and saving this Agreement.
								</li>
							</ol>
							<p>&nbsp;</p>
							<ol start='3'>
								<li>
									<u>Revocation of Agreement</u>. You have the right to withdraw your consent to receive/obtain text message and/or email notification communications from the Company at any time. If you wish to withdraw your consent, you may update your preferences online via your Member Portal account, or by opting-out via a reply text message.
								</li>
							</ol>
							<p style={{ marginLeft: '.5in' }}>&nbsp;</p>
							<ol start='4'>
								<li>
									<u>Change of Phone Number</u>. You agree to notify the Company if the phone number you provide is no longer a valid phone number to reach you via text message. You acknowledge that failure to notify the Company of the change, transfer, or cancellation of the phone number provided in this Agreement may result in a third party seeing the text messages you have authorized. You agree not to hold the Company responsible for disclosure of information directly resulting from text messages sent to the number(s) provided in this Agreement if you have not notified the Company of the change, transfer, or cancellation of the phone number. If your phone number is changed, transferred, or cancelled, you may contact us at 800.477.1660.
								</li>
							</ol>
							<p>&nbsp;</p>
							<ol start='5'>
								<li>
									<u>Change of Email Address</u>. You agree to notify the Company if the email address you provide is no longer a valid email address to reach you. You acknowledge that failure to notify the Company of the change, transfer, or cancellation of the email address provided in this Agreement may result in a third party seeing the email messages you have authorized. You agree not to hold the Company responsible for disclosure of information directly resulting from email messages sent to the email address provided in this Agreement if you have not notified the Company of the change, transfer, or cancellation of the email address provided. If your email address is changed, transferred, or cancelled, you may contact us at 800.477.1660.
								</li>
							</ol>
							<p style={{ marginLeft: '.5in' }}>&nbsp;</p>
							<p>To obtain Automatic Text Messages or Email Notification/Information, indicate your consent to the terms and conditions of this Agreement by clicking on the "Accept" button.</p>
							<p>&nbsp;</p>
							<p>It is recommended that you print a copy of this Agreement for future reference.</p>
						</div>
					</Modal.Content>
					<Modal.Actions>
						<Button primary content='Accept' onClick={this.onRealSave} />
						<Button content='Cancel' onClick={this.onCloseSuccess} />
					</Modal.Actions>
				</Modal>
				<Modal size='tiny' open={showSuccess}>
					<Modal.Content>
						<Header as='h1' content='Your changes have been saved.' />
					</Modal.Content>
					<Modal.Actions>
						<Button primary content='OK' onClick={this.onCloseSuccess} />
					</Modal.Actions>
				</Modal>
				<Modal size-='tiny' open={showError}>
					<Modal.Content>
						<Header as='h1'>{errorHeader}</Header>
						{error}
					</Modal.Content>
					<Modal.Actions>
						<Button primary content='OK' onClick={this.onCloseSuccess} />
					</Modal.Actions>
				</Modal>
				<Header as='h3' content='Manage Your Alerts' color='red' />
				<div style={{ display: 'flex' }}>
					<Header as='h4' content='Receive all your documents and notifications electronically' />
					<div style={{ flex: 'column', marginLeft: '15px' }}>
						<Header as='h4' content='Off' style={{ color: '#8e3a16' }} />
					</div>
					<Checkbox name='isDelivery' className={styles.docCheckbox} toggle checked={profile.isDelivery} onChange={this.onToggleDelivery} disabled={editMobileNumber} />
					<div style={{ flex: 'column', marginLeft: '15px' }}>
						<Header as='h4' content='On' style={{ color: '#8e3a16' }} />
					</div>
				</div>
				{profile.isDelivery && (
					<div>
						<Header as='h4' content='Alerts will be sent to:' />
						<div style={{ display: 'flex' }}>
							<p>{`Email Address: ${profile.email}`}</p>
							{editMobileNumber ? (
								<div style={{ display: 'flex', marginLeft: '30px', alignItems: 'center' }}>
									<Input name='phoneNumber' onChange={this.onPhoneNumberChange} value={phoneNumber} />
									<a style={{ marginLeft: '5px' }} href='/profile/security/username' onClick={this.onSaveMobile}>
										<Header as='h4' content='save' style={{ color: '#4183c4', margin: 10 }} />
									</a>{' '}
									<a style={{ marginLeft: '5px' }} href='/profile/security/username' onClick={this.onCancelMobileEdit}>
										<Header as='h4' content='cancel' style={{ color: '#4183c4', margin: 10 }} />
									</a>
								</div>
							) : (
								<div style={{ display: 'flex', marginLeft: '30px' }}>
									<p style={{ marginRight: '15px' }}>{`Mobile Number: ${profile.phoneNumber || ''}`}</p>{' '}
									<a href='/profile/security/username' onClick={this.onEditMobile}>
										<Header as='h4' content='edit' style={{ color: '#4183c4' }} />
									</a>
								</div>
							)}
						</div>
						<div>
							<Header as='h4'>Additional recipients:</Header>

							<div className={styles.recipientContainer}>
								<div className={styles.email}>
									<Form onSubmit={this.onAddAdditionalEmailAddress}>
										<Form.Field>
											<label>Email Address</label>
											<Input
												name='additionalEmailAddress'
												value={additionalEmailAddress}
												action={{
													color: 'green',
													labelPosition: 'right',
													icon: 'add',
													content: 'Add',
													disabled: additionalEmailAddress === '',
												}}
												onChange={this.onAdditionalEmailAddressChange}
												type="email"
											/>
										</Form.Field>
									</Form>
									{additionalEmailAddressError && <Message error content='Email Address already exists' />}
									<List>
										{profile.additionalEDeliveryEmailRecipients.map((r, i) => {
											return (
												<List.Item key={i}>
													<List.Icon name='close' color='red' link onClick={() => this.onRemoveAdditionalEmailAddress(r)} />
													<List.Content>{r}</List.Content>
												</List.Item>
											);
										})}
									</List>
								</div>
								{profile.phoneNumber && profile.phoneNumber !== '' && (
									<div className={styles.phone}>
										<Form onSubmit={this.onAddAdditionalPhoneNumber}>
											<Form.Field>
												<label>Mobile Number</label>
												<Input
													name='additionalPhoneNumber'
													value={additionalPhoneNumber}
													action={{
														color: 'green',
														labelPosition: 'right',
														icon: 'add',
														content: 'Add',
														disabled: additionalPhoneNumber === '',
													}}
													onChange={this.onAdditionalPhoneNumberChange}
													type="number"
												/>
											</Form.Field>
										</Form>
										{additionalPhoneNumberError && <Message error content='Mobile number already exists' />}
										<List>
											{profile.additionalEDeliverySMSRecipients.map((r, i) => {
												return (
													<List.Item key={i}>
														<List.Icon name='close' color='red' link onClick={() => this.onRemoveAdditionalPhoneNumber(r)} />
														<List.Content>{r}</List.Content>
													</List.Item>
												);
											})}
										</List>
									</div>
								)}
							</div>
						</div>
						<div style={{ display: 'flex', marginTop: '30px' }}>
							<div className={styles.alertCol}>
								<Header as='h4' content='Alert Type' color='red' />
								<p>New Document</p>
							</div>
							<div style={{ display: 'flex', flex: '2' }}>
								<div style={{ display: 'flex', flexDirection: 'column', marginLeft: '15px' }}>
									<Header as='h4' content='Description' color='red' />
									<p>Receive an alert when a new policy document is available on your account at IndianaFarmers.com</p>
									<ul style={{ paddingLeft: '20px', margin: '0' }}>
										<li>New Declarations Page</li>
										<li>Invoice</li>
										<li>Renewal Documents</li>
										<li>Notices</li>
									</ul>
								</div>
								<div style={{ flex: 'column', marginLeft: '15px' }}>
									<Header as='h4' content='Email' style={{ color: '#8e3a16' }} />
									<Checkbox name='isDeliveryViaEmail' toggle checked={profile.isDeliveryViaEmail} onChange={this.onToggleDelivery} disabled={editMobileNumber} />
								</div>
								<div style={{ flex: 'column', marginLeft: '15px' }}>
									<Header as='h4' content='Text' style={{ color: '#8e3a16' }} />
									<Checkbox name='isDeliveryViaText' disabled={!phoneNumber || phoneNumber.trim() === '' || editMobileNumber} toggle checked={profile.isDeliveryViaText} onChange={this.onToggleDelivery} />
								</div>
							</div>
						</div>
						<div style={{ display: 'flex', marginTop: '30px' }}>
							<div className={styles.alertCol}>
								<p>Payments</p>
							</div>
							<div style={{ display: 'flex', flexDirection: 'column', marginLeft: '15px', flex: '2' }}>
								<p>Receive an alert when:</p>
								<ul style={{ paddingLeft: '20px', margin: '0' }}>
									<li>Payment is due</li>
									<li>Payment is due in 7 days</li>
									<li>Payment is late</li>
									<li>Payment is posted</li>
								</ul>
							</div>
						</div>
						<div style={{ display: 'flex', marginTop: '30px' }}>
							<div className={styles.alertCol}>
								<p>Claims</p>
							</div>
							<div style={{ display: 'flex', flexDirection: 'column', marginLeft: '15px', flex: '2' }}>
								<p>Receive an alert when:</p>
								<ul style={{ paddingLeft: '20px', margin: '0' }}>
									<li>Claim received along with claim number</li>
									<li>Your adjuster's contact information</li>
									<li>A payment has been issued</li>
									<li>Your adjuster is trying to reach you</li>
								</ul>
							</div>
							<div style={{ flex: 'column', marginLeft: '15px' , display: 'none'}}>
								<Header as='h4' content='Email' style={{ color: '#8e3a16' }} />
								<Checkbox name='isClaimDeliveryViaEmail' toggle checked={profile.isClaimDeliveryViaEmail} onChange={this.onToggleDelivery} disabled={true} />
							</div>

							<div style={{ flex: 'column', marginLeft: '15px', display: 'none' }}>
								<Header as='h4' content='Text' style={{ color: '#8e3a16' }} />
								<Checkbox name='isClaimDeliveryViaText' disabled={true || !phoneNumber || phoneNumber.trim() === '' || editMobileNumber} toggle checked={profile.isClaimDeliveryViaText} onChange={this.onToggleDelivery} />
							</div>
						</div>
					</div>
				)}

				<Button style={{ marginTop: '15px' }} disabled={editMobileNumber} primary content='Save Changes' onClick={this.onSave} />
			</div>
		);
	}
}

ElectronicDelivery.propTypes = {};

const mapStateToProps = (state, ownProps) => {
	return {
		profile: profileSelector(state),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(profileActions, dispatch),
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ElectronicDelivery);
